import React, { Component } from 'react';
import { SocialIcon } from 'react-social-icons';
import ReactGA from 'react-ga';

export class Product extends Component {

    initializeReactGA() {
        ReactGA.initialize('UA-147472286-2');
        ReactGA.pageview('/products');
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            products: []

        }
        this.initializeReactGA();
    };

    async populateProductsData() {
        const response = await fetch('api/Product/GetAll');
        const data = await response.json();
        this.setState({ products: data, loading: false });
    };


    componentDidMount() {
        this.populateProductsData();
    };

    static renderProducts(products) {
        var content = [];
        var productbyRow = [];
        var i = 1;
        while (i <= products.length) {
            productbyRow.push(products[i - 1]);
            if (productbyRow.length === 3 || i === products.length) {
                content.push(
                    <div className="card-group" key={i}>
                        {productbyRow.map(p =>
                            <div className="card" key={p.code}>
                                <img src={p.imgUrl} style={{ height: "250px" }} className="card-img-top" alt={p.title} />
                                <div className="card-body">
                                    <h5 className="card-title">{p.title}</h5>
                                    <p className="card-text">{p.description}</p>
                                </div>
                                <div className="card-footer"/>
                                    
                            </div> 
                        )}
                    </div>
                )
                productbyRow.splice(0, productbyRow.length)
            }
            i++;
        }
        return content;
    };

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : Product.renderProducts(this.state.products);

        return (
            <div>
                <div style={{
                    position: "fixed",
                    top: "50%",
                    transform: "translateY(-50%)",
                    right: "10px",
                    zIndex: "1"
                }}>
                    <SocialIcon url="https://api.whatsapp.com/send?phone=593987394954" />
                </div>
                <div className="card sticky-top">
                    <h1>Productos</h1>
                </div>
                <div className="container">
                    
                        {contents}
                    
                </div>
            </div>
        );
    }
}
